<template>
	<Transition
		enterActiveClass="transition-all duration-500"
		enterFromClass="opacity-0 scale-0"
	>
		<BaseButton
			color="secondary"
			size="sm"
			borderRounded
			@click="layout.showDepositModal()"
			v-if="user.displayCoins && user.uuid"
			class="relative"
		>
			<CoinPrice
				class="text-label-primary"
				:price="coins"
				:minDigits="2"
				mono
				:animationDuration="firstUpdate ? 1000 : undefined"
			/>
			<PlusIcon class="text-red h-5 w-5" />
		</BaseButton>
	</Transition>
</template>
<script setup lang="ts">
import BaseButton from './BaseButton.vue'
import { useLayout } from '@/stores/layout'
import CoinPrice from './CoinPrice.vue'
import PlusIcon from '@/assets/icons/plus.svg'
import { useUser } from '@/stores/user'
import { ref, watch } from 'vue'

const user = useUser()
const layout = useLayout()

const coins = ref(user.displayedCoins)
const firstUpdate = ref(false)

watch(
	() => user.displayedCoins,
	async (newVal) => {
		if (!firstUpdate.value) {
			firstUpdate.value = true
		}

		coins.value = newVal
	}
)
</script>
